var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrTreeDot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2345_6894)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0.625C3.604 0.625 4.5 1.55833 4.5 2.70833C4.5 3.85833 3.604 4.79167 2.5 4.79167C1.396 4.79167 0.5 3.85833 0.5 2.70833C0.5 1.55833 1.396 0.625 2.5 0.625ZM4.5 10C4.5 8.85 3.604 7.91667 2.5 7.91667C1.396 7.91667 0.5 8.85 0.5 10C0.5 11.15 1.396 12.0833 2.5 12.0833C3.604 12.0833 4.5 11.15 4.5 10ZM4.5 17.2917C4.5 16.1417 3.604 15.2083 2.5 15.2083C1.396 15.2083 0.5 16.1417 0.5 17.2917C0.5 18.4417 1.396 19.375 2.5 19.375C3.604 19.375 4.5 18.4417 4.5 17.2917Z",
    fill: "#111111",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2345_6894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 4,
    fill: "white",
    transform: "matrix(0 1 -1 0 4.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrTreeDot);
export default __webpack_public_path__ + "static/media/hr_tree_dot.45253a52f44478dd71a90c8d50e91e78.svg";
export { ForwardRef as ReactComponent };